import API from 'services/api';

export const completeWorkflowStep = (stepId: string) =>
  API.post(`/api/workflow/tasks/complete-step/${stepId}`);
